/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';

import TFinderLayout from '@/components/Taktify/TFinderLayout.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TSearchField from '@/components/Taktify/TSearchField.component.vue';
import TProgressCircle from '@/components/Taktify/TProgressCircle.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';


import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';

import WorkBenchWorkPackage from '@/components/WorkBench/WorkBenchWorkPackage.component.vue';
import WorkBenchWorkPackageHeader from '@/components/WorkBench/WorkBenchWorkPackageHeader.component.vue';
import WorkBenchSequence from '@/components/WorkBench/WorkBenchSequence.component.vue';

import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import SequencePicker from '@/components/ProjectTaktPlan/SequencePicker.component.vue';
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue';
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue';
import StatisticsBeamTaktSum from '@/components/ProjectTaktPlan/StatisticsBeamTaktSum.component.vue';


export const WorkBenchMixin = {
  components: {
    TFinderLayout,
    TFlex,
    TSearchField,
    TProgressCircle,
    TIcon,

    StandardFlexBox,
    StandardBadge,

    WorkBenchWorkPackage,
    WorkBenchWorkPackageHeader,
    WorkBenchSequence,

    TrainHead,
    TrainTail,
    Waggon,
    WorkPackage,
    SequencePicker,
    StatisticsTakt,
    StatisticsBeam,
    StatisticsBeamTaktSum,

    },
  data: () => ({
    loading: true,
    hover_sequence_steps_beam_icon: false,
    hover_sequence_images_beam_icon: false,
    hover_sequence_values_beam_icon: false,
  }),
  computed: {
    ...mapGetters('WorkBench', [
      'getWBObject',
      'getWBObjects',
      'getWBObjectsFiltered',
      'getAISequenceWaggons',
      'getSequenceStatistics',
      'getSequenceWorkpackageColors',
      'getSequenceWorkpackageIcons',
      'getWorkpackagesMaxChildren',
      'isWBObjEmpty',
      'getWBObjectsSearch'
    ]),
    ...mapGetters('WorkBenchLocal', [
      'getWBLObject',
    ]),
    ...mapGetters('WorkPackage', [
      'getNewIcon',
      'getWorkPackageIcons'
    ]),
    ...mapGetters('WorkBenchSequence', [
      'getSequencePreviewStatistics',
    ]),
    ...mapGetters('Auth', [
      'getUser',
      'hasPermission'
    ]),
    prefix(){
      switch (this.$route.params.template_type) {
        case 'custom':
          return '';
        case 'company':
          return 'b';
        case 'community':
          return 'c';
      }
    },
    workbench_variables() {
      return this.getWBLObject({
        path: [
          {workbench_variables: ''}
        ]
      });
    },
    sequencePreviewStatistics() {
      let statistics = this.getSequencePreviewStatistics;
      return statistics;
    },
  },
  methods: {
    ...mapActions('WorkBench', [
      'requestWBObject',
      'createWBObject',
      'updateWBObject',
      'updateWBObjectHashtags',
      'deleteWBObject',
      'changeWBObjectParent',
      'changeWBObjectPosition',
      'changeWBObjectFolder',
      'addLoadAll',
      'resetSearch',
      'exportMasterialCSV',
      'exportWorkpackageCSV',
    ]),
    ...mapActions('WorkBenchLocal', [
      'createWBLObject',
      'updateWBLObject',
      'deleteWBLObject',
    ]),
    downloadWorkpackageImportTemplate(){
    // Your logic to generate CSV data
    const csv_data = 'external_id,icon,token,color,name,description,workstep_1,workstep_2,workstep_3,workstep_4,workstep_5,workstep_6,workstep_7,workstep_8,workstep_9,workstep_10,qualitystep_1,qualitystep_2,qualitystep_3,qualitystep_4,qualitystep_5,qualitystep_6,qualitystep_7,qualitystep_8,qualitystep_9,qualitystep_10,logisticstep_1,logisticstep_2,logisticstep_3,logisticstep_4,logisticstep_5,logisticstep_6,logisticstep_7,logisticstep_8,logisticstep_9,logisticstep_10';
    const csv_content = "data:text/csv;charset=utf-8," + encodeURIComponent(csv_data);
    const link = document.createElement("a");
    link.setAttribute("href", csv_content);
    link.setAttribute("download", "takting_workpackage_import_template.csv");
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link);
    },
    importWorkpackagesFromCSV(csv_file){
      // this.new_image.file = img;
      // this.new_image.image = URL.createObjectURL(img);

      let image = new FormData();
      image.append("workpackages", csv_file);

      this.createWBObject({
        url: [
          {workpackages: 'csvimport'},
          {showWithEntitiesNormalized: ''}
        ],
        wb_object: image
      })
    },
    resetSearchBar() {
      console.log('reset')
      this.resetSearch()
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
        })
    },
    getProgressCircular(workpackage, circle) {
      if (circle === 'steps') {
        let steps = 0;
        let steps_count = 0;
        let segments = [
          {value: false, icon: 'takt_workstep', count: 0},
          {value: false, icon: 'takt_quality', count: 0},
          {value: false, icon: 'takt_defect', count: 0},
          {value: false, icon: 'takt_handover', count: 0},
          {value: false, icon: 'takt_logistic', count: 0},
          {value: false, icon: 'takt_design', count: 0},
          {value: false, icon: 'takt_material', count: 0},
        ];
        // let max = this.getWorkpackagesMaxChildren({sequence_preview: false}).steps;
        ['work', 'quality', 'defect', 'handover', 'logistic', 'design', 'material'].forEach((type, index) => {
            steps_count = steps_count + workpackage[`${this.prefix}w${type}steps`].length;
            if (workpackage[`${this.prefix}w${type}steps`].length !== 0) {
              steps++;
              segments[index].value = true;
              segments[index].count = workpackage[`${this.prefix}w${type}steps`].length;
            }
        });
        // if (max === 0) {
        //   return {
        //     percentage: 0,
        //     value: steps_count,
        //   };
        // } else {
          // return {
          //   percentage: steps_count /  max * 100,
          //   value: steps_count,
          // };
        // }
        return {
            percentage: (steps /  segments.length) * 100,
            total: steps_count,
            segments: segments
        };
      }
      if (circle === 'images' && workpackage[`${this.prefix}wworkpackageimages`]) {
        let images_count = workpackage[`${this.prefix}wworkpackageimages`].length;
        let images = 0;
        let segments = [
          {value: false, icon: 'image', count: 0},
        ];
        if (workpackage[`${this.prefix}wworkpackageimages`].length !== 0) {
          images = 1;
          segments[0].value = true;
          segments[0].count = workpackage[`${this.prefix}wworkpackageimages`].length;
        }
        return {
              percentage: (images / 1) * 100,
              total: images_count,
              segments: segments
        };
      }
      if (circle === 'images' && workpackage[`${this.prefix}workpackageimages`]) {
        let images_count = workpackage[`${this.prefix}workpackageimages`].length;
        let images = 0;
        let segments = [
          {value: false, icon: 'image', count: 0},
        ];
        if (workpackage[`${this.prefix}workpackageimages`].length !== 0) {
          images = 1;
          segments[0].value = true;
          segments[0].count = workpackage[`${this.prefix}workpackageimages`].length;
        }
        return {
              percentage: (images / 1) * 100,
              total: images_count,
              segments: segments
        };
      }
      if (circle === 'values') {
        let values = 0;
        let segments = [
          {value: false, icon: 'speed'},
          {value: false, icon: 'accessibility'},
          {value: false, icon: 'account_balance_wallet'},
          {value: false, icon: 'account_balance_wallet'},
          {value: false, icon: 'drag_indicator'},
          {value: false, icon: 'drag_indicator'},
        ];
        [
          'time_effort_planned',
          'manpower_planned',
          'costs_budget_labour',
          'costs_budget_material',
          'quantity_value',
        ].forEach((type, index) => {
          if (parseInt(workpackage[type]) !== 0) {
            values++;
            segments[index].value = true;
          }
        });
        if (workpackage.quantity_unit !== '') {
          values++;
          segments[5].value = true;
        }
        return {
          percentage: (values /  segments.length) * 100,
          total: 0,
          segments: segments
        };
      }
    },
  }
};
